import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL } from "../../variables/constants";
import { ToastContainer } from 'react-toastify';
import { Form, Button, Typography, Row, Col, Select, Upload } from 'antd';
import entete from "../../assets/img/entete_pool.png";
import poolins from "../../assets/img/poolins.jpg";
import axiosInstance from "../../variables/api/axiosInstance";
import { UploadOutlined } from "@ant-design/icons";
import axiosMultiPartDataInstance from "../../variables/api/axiosMultiPartDatainstance";

const { Title, Text } = Typography;

// ===== Utils & constantes =====
const TODAY_ISO = new Date().toISOString().slice(0, 10);
const onlyDigits = (s = "") => s.replace(/\D/g, "");
const formatTgPhone = (s = "") => {
  // 8 chiffres, affichage "00 00 00 00"
  const digits = onlyDigits(s).slice(0, 8);
  return digits.replace(/(\d{2})(?=\d)/g, "$1 ").trim();
};
const formatCNI = (s = "") => {
  // 4-3-4 => 0000-000-0000 (tirets automatiques)
  const d = onlyDigits(s).slice(0, 11);
  const p1 = d.slice(0, 4);
  const p2 = d.slice(4, 7);
  const p3 = d.slice(7, 11);
  return [p1, p2, p3].filter(Boolean).join("-");
};
const parseISO = (v) => (v ? new Date(v) : null);
const yearsBetween = (d1, d2) => {
  if (!d1 || !d2) return 0;
  let age = d2.getFullYear() - d1.getFullYear();
  const m = d2.getMonth() - d1.getMonth();
  if (m < 0 || (m === 0 && d2.getDate() < d1.getDate())) age--;
  return age;
};

const Register = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [insurances, setInsurances] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API_URL}/api/organisme/all/assurances`).then(response => {
      if (response.data) {
        setInsurances(response.data);
      }
    }).catch(error => {
      console.error("Erreur lors de la récupération des logos des assurances:", error);
    });
  }, []);

  const [activeTab, setActiveTab] = useState(1);
  const [villes, setVilles] = useState([]);
  const [assurances, setAssurances] = useState([]);
  const [formData, setFormData] = useState({
    raisonSociale: "",
    siegeSocial: "",
    ville: "",
    email: "",
    nif: "",
    nomResponsable: "",
    prenomResponsable: "",
    emailResponsable: "",
    genreResponsable: "MASCULIN",
    adresseResponsable: "",
    telephoneResponsable: "",
    typePieceResponsable: "CNI",
    numIdentiteResponsable: "",
    dateNaissanceResponsable: "", // ✅ ajouté
    dateDelivranceResponsable: "",
    lieuDelivranceResponsable: "",
    telephone1: "",
    telephone2: "",
    active: "",
    agrements: [],
  });
  const [errors, setErrors] = useState({});
  const [selectedCompagnies, setSelectedCompagnies] = useState([]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  // ====== Saisie contrôlée: téléphone & CNI & dates ======
  const handlePhoneChange = (e) => {
    const { name, value } = e.target; // telephone1 | telephone2 | telephoneResponsable
    setFormData((p) => ({ ...p, [name]: formatTgPhone(value) }));
  };
  const handleCNIChange = (e) => {
    const { value } = e.target;
    setFormData((p) => ({ ...p, numIdentiteResponsable: formatCNI(value) }));
  };
  const digitsOnlyKeyDown = (e) => {
    // autorise chiffres, touches contrôle, et raccourcis (copier/coller)
    const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Home", "End"];
    if (allowed.includes(e.key) || (e.ctrlKey || e.metaKey) || /\d/.test(e.key)) return;
    e.preventDefault();
  };
  const handleDOBChange = (e) => {
    const { value } = e.target; // yyyy-mm-dd
    setFormData((p) => ({ ...p, dateNaissanceResponsable: value }));
  };
  const handleDateDelivranceChange = (e) => {
    const { value } = e.target;
    setFormData((p) => ({ ...p, dateDelivranceResponsable: value }));
  };

  const [agreements, setAgreements] = useState([]);


  const onChangeFileSelect = (e, code) => {
    console.log("FileSelected: ", e);
  };

  const onChangeBeforeUploadFileSelect = (e, code) => {
    console.log("FileSelecteddddd: ", e);
    let agr = [...agreements];
    let fa = agr.findIndex((ag) => ag.company.code === code);
    e.status = "done";
    agr[fa].document = e;
    setAgreements(agr);
  };

  useEffect(() => {
    axiosInstance
      .get(`/api/parametre/villes`)
      .then((res) => {
        console.log("Villes: ", res.data);
        setVilles(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    axiosInstance
      .get(`/api/organisme/assurance`)
      .then((res) => {
        setAssurances(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleSelectCompagniesChange = (value) => {
    let agrs = [];
    value.forEach((element) => {
      agrs.push({
        company: JSON.parse(element),
        document: [],
      });
    });

    setAgreements(agrs);
    setSelectedCompagnies(value);
  };

  const validateForm = () => {
    const newErrors = {};
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phonePattern = /^(22|90|91|92|93|96|98|99|70|71|79)\d{6}$/;

    if (!formData.raisonSociale)
      newErrors.raisonSociale = "La dénomination sociale est requise";
    if (formData.raisonSociale && formData.raisonSociale.length < 3)
      newErrors.raisonSociale = "La dénomination sociale est trop courte";
    if (!formData.siegeSocial)
      newErrors.siegeSocial = "Le siège social est requis";
    if (formData.siegeSocial && formData.siegeSocial.length < 3)
      newErrors.siegeSocial = "Le siège social est trop court";
    if (!formData.email)
      newErrors.email = "L'adresse mail de la société est requise";
    if (formData.email && !emailPattern.test(formData.email))
      newErrors.email = "L'adresse mail n'est pas valide !";

    const tel1Digits = onlyDigits(formData.telephone1);
    if (!phonePattern.test(tel1Digits))
      newErrors.telephone1 = "Le numéro de téléphone n'est pas valide !";

    const nif = String(formData.nif ?? "").trim();
    if (!nif) {
      newErrors.nif = "Le NIF est requis";
    } else if (!/^\d{11,}$/.test(nif)) {
      newErrors.nif = "Le NIF n'est pas valide !";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateUserForm = () => {
    const newErrors = {};
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phonePattern = /^(22|90|91|92|93|96|98|99|70|71|79)\d{6}$/;

    if (!formData.nomResponsable)
      newErrors.nomResponsable = "Le nom est requise";
    if (!formData.nif) newErrors.nif = "Le Nif  est requis";
    if (formData.nomResponsable && formData.nomResponsable.length < 3)
      newErrors.nomResponsable = "Le nom est trop court";
    if (!formData.prenomResponsable)
      newErrors.prenomResponsable = "Le prénom est requis";
    if (formData.prenomResponsable && formData.prenomResponsable.length < 3)
      newErrors.prenomResponsable = "Le prénom est trop court";
    if (!formData.emailResponsable)
      newErrors.emailResponsable = "Votre adresse mail est requise";
    if (
      formData.emailResponsable &&
      !emailPattern.test(formData.emailResponsable)
    )
      newErrors.emailResponsable = "L'adresse mail n'est pas valide!";

    const telDigits = onlyDigits(formData.telephoneResponsable);
    if (!phonePattern.test(telDigits))
      newErrors.telephoneResponsable =
        "Le numéro de téléphone n'est pas valide!";

    // CNI auto-formatée 4-3-4 => 11 chiffres requis
    const cniDigits = onlyDigits(formData.numIdentiteResponsable);
    if (formData.typePieceResponsable === "CNI") {
      if (cniDigits.length !== 11)
        newErrors.numIdentiteResponsable =
          "Le format de la CNI doit être 0000-000-0000";
    } else if (formData.typePieceResponsable === "PASSEPORT") {
      // exemple simple (adapter si besoin)
      if (!/^[A-Za-z]{1,2}\d{5,}$/.test(formData.numIdentiteResponsable))
        newErrors.numIdentiteResponsable = "Le format du passeport est invalide";
    }

    // Dates
    const dob = parseISO(formData.dateNaissanceResponsable);
    if (!dob) {
      newErrors.dateNaissanceResponsable =
        "La date de naissance est requise";
    } else {
      const today = new Date();
      const age = yearsBetween(dob, today);
      if (dob > today)
        newErrors.dateNaissanceResponsable =
          "La date de naissance ne peut pas être dans le futur";
      else if (age < 18)
        newErrors.dateNaissanceResponsable = "Âge minimum requis: 18 ans";
      else if (age > 120)
        newErrors.dateNaissanceResponsable = "Âge invalide (>120 ans)";
    }

    const del = parseISO(formData.dateDelivranceResponsable);
    if (!del) {
      newErrors.dateDelivranceResponsable =
        "La date de délivrance est requise";
    } else {
      const today = new Date();
      if (del > today)
        newErrors.dateDelivranceResponsable =
          "La date de délivrance ne peut pas être future";
      if (dob && del < dob)
        newErrors.dateDelivranceResponsable =
          "La date de délivrance ne peut pas être antérieure à la naissance";
    }

    if (!formData.lieuDelivranceResponsable)
      newErrors.lieuDelivranceResponsable =
        "Le lieu de délivrance est requis";

    console.log("fddd", formData);

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    console.log(formData);
    console.log(agreements);
    if (selectedCompagnies.length) {
      let verif = true;
      agreements.forEach((ag) => {
        if (!ag.document || ag.document.length === 0) {
          verif = false;
        }
      });
      if (verif) {
        setLoading(true);
        console.log("Nice");

        const data = new FormData();

        agreements.forEach((ag, id) => {
          let extension = ag?.document?.name?.substring(
            ag?.document?.name?.lastIndexOf(".") + 1,
            ag?.document?.name?.length
          );
          let filename = `Agreement_${ag?.company?.code
            }_${formData.raisonSociale.split(" ").join("_")}.${extension}`;
          data.append("fichier", ag.document, filename);
          data.append("compagnies", ag.company.code);
        });

        axiosMultiPartDataInstance
          .post(`/api/agreement/all`, data)
          .then((res) => {
            console.log(res.data);
            const courtier = {
              raisonSociale: formData.raisonSociale,
              siegeSocial: formData.siegeSocial,
              ville: formData.ville,
              email: formData.email,
              nif: formData.nif,
              nomResponsable: formData.nomResponsable,
              prenomResponsable: formData.prenomResponsable,
              emailResponsable: formData.emailResponsable,
              genreResponsable: formData.genreResponsable,
              adresseResponsable: formData.adresseResponsable,
              telephoneResponsable: [onlyDigits(formData.telephoneResponsable)],
              typePieceResponsable: formData.typePieceResponsable,
              numIdentiteResponsable: onlyDigits(
                formData.numIdentiteResponsable
              ),
              dateNaissanceResponsable: formData.dateNaissanceResponsable,
              dateDelivranceResponsable: formData.dateDelivranceResponsable,
              lieuDelivranceResponsable: formData.lieuDelivranceResponsable,
              contact: formData.telephone2
                ? [onlyDigits(formData.telephone1), onlyDigits(formData.telephone2)]
                : [onlyDigits(formData.telephone1)],
              agreements: res.data,
            };

            console.log("Courtier: ", courtier);
            axiosInstance
              .post(`/api/agence/courtier`, JSON.stringify(courtier))
              .then((resp) => {
                console.log(resp.data);
                toast("Enregistrement effectué avec succès!");
                setLoading(false);
                navigate("/waiting");
              })
              .catch((err) => {
                console.log(err);
                toast("Erreur lors de l'enregistrement'");
                setLoading(false);
              });
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
      } else {
        setLoading(false);
        toast("Veuillez joindre tous vos agréements");
        setLoading(false);
      }
    } else {
      toast(
        "Veuillez sélectionner les compagnies avec lesquelles vous avez des agréements"
      );
      setLoading(false);
    }
  };

  return (
    <div style={{
      height: '100vh',
      backgroundImage: 'url(assets/img/landing.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      display: 'flex',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Overlay léger pour améliorer la lisibilité */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(36, 33, 102, 0.12)',
        backdropFilter: 'blur(10px)',
        zIndex: 0
      }} />

      <ToastContainer position="top-center" />

      <Row style={{ width: '100%', height: '100%', margin: 0, zIndex: 1 }}>
        {/* Section gauche - Branding avec effet glass */}
        <Col xs={24} lg={10} style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '40px',
          background: 'rgba(255, 255, 255, 0.08)',
          backdropFilter: 'blur(1px)',
          borderRight: '1px solid rgba(255, 255, 255, 0.15)',
          boxShadow: 'inset 0 0 60px rgba(255, 255, 255, 0.05)',
          height: '100%',
          overflowY: 'auto'
        }}>
          <div style={{
            width: '100%',
            maxWidth: '600px',
            display: 'flex',
            flexDirection: 'column',
            gap: '32px'
          }}>

            <Text style={{
              color: 'rgba(255, 255, 255, 0.95)',
              textAlign: 'center',
              display: 'block',
              fontSize: '17px',
              lineHeight: '1.6',
              fontWeight: '500',
              textShadow: '0 2px 8px rgba(0, 0, 0, 0.3)'
            }}>
              Plateforme de gestion des activités du Pool TPVM-VT GIE
            </Text>

            {/* Logo Pool */}
            <div style={{
              background: 'rgba(255, 255, 255, 0.95)',
              borderRadius: '20px',
              padding: '40px',
              textAlign: 'center',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              transition: 'transform 0.3s ease'
            }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-4px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <img
                src={entete}
                alt="Pool TPVM-VT GIE"
                style={{
                  width: '100%',
                  height: 'auto'
                }}
              />
            </div>

            {/* Logos des compagnies */}
            <div style={{
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '20px',
              padding: '32px 24px',
              border: '1px solid rgba(255, 255, 255, 0.15)',
              backdropFilter: 'blur(10px)'
            }}>
              <Text style={{
                color: 'rgba(255, 255, 255, 0.95)',
                display: 'block',
                marginBottom: '24px',
                fontSize: '15px',
                fontWeight: '700',
                textAlign: 'center',
                letterSpacing: '1px',
                textTransform: 'uppercase',
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
              }}>
                Les Compagnies Membres
              </Text>
              <Row gutter={[16, 16]} justify="center" align="middle">
                {insurances?.map((ins, i) => (
                  <Col xs={12} sm={8} key={i}>
                    <div style={{
                      background: 'rgba(255, 255, 255, 0.98)',
                      borderRadius: '14px',
                      padding: '18px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      minHeight: '90px',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      border: '1px solid rgba(36, 33, 102, 0.1)'
                    }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-6px)';
                        e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.25)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
                      }}
                    >
                      <img
                        src={`data:image/png;base64,${ins.logoDisplay}`}
                        alt={ins.raisonSociale || `Logo ${i + 1}`}
                        style={{
                          maxWidth: '100%',
                          maxHeight: '60px',
                          objectFit: 'contain'
                        }}
                      />
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        </Col>

        {/* Section droite - Formulaire */}
        <Col xs={24} lg={14} style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px 24px',
          background: 'white',
          height: '100%',
          overflowY: 'auto'
        }}>
          <div style={{
            width: '100%',
            maxWidth: '480px',
            height: '100%'
          }}>
            {/* Logo au-dessus du formulaire */}
            <div style={{
              textAlign: 'center',
              marginBottom: '0px'
            }}>
              {/* Logo PoolIns */}
              <div style={{
                textAlign: 'center',
                animation: 'fadeInDown 0.8s ease-out'
              }}>
                <img
                  src={poolins}
                  alt="PoolIns"
                  style={{
                    maxWidth: '240px',
                    width: '100%',
                    height: 'auto',
                    borderRadius: '20px',
                    transition: 'transform 0.3s ease',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                />
              </div>

              <Title level={2} style={{
                color: '#242166',
                margin: 0,
                fontSize: '32px',
                fontWeight: '700',
                marginBottom: '8px'
              }}>
                Enregistrement de courtier
              </Title>
              <Text style={{
                color: '#64748b',
                fontSize: '16px'
              }}>
                Accédez à votre espace sécurisé
              </Text>
            </div>

            {/* Formulaire */}
            <div class="d-flex col-lg-7 align-items-center justify-content-center authentication-bg p-5">
              <div class="w-px-700">
                <div
                  id="multiStepsValidation"
                  class="bs-stepper border-none shadow-none mt-5"
                >
                  <div class="bs-stepper-header border-none pt-12 px-0">
                    <div
                      class={activeTab === 1 ? "step active" : "step"}
                      data-target="#accountDetailsValidation"
                    >
                      <button
                        type="button"
                        class="step-trigger"
                        onClick={() => setActiveTab(1)}
                      >
                        <span class="bs-stepper-circle">
                          <i class="bx bx-home"></i>
                        </span>
                        <span class="bs-stepper-label">
                          <span class="bs-stepper-title">Informations</span>
                          <span class="bs-stepper-subtitle">
                            Détails sur la société de courtage
                          </span>
                        </span>
                      </button>
                    </div>
                    <div class="line">
                      <i class="bx bx-chevron-right"></i>
                    </div>
                    <div
                      class={activeTab === 2 ? "step active" : "step"}
                      data-target="#personalInfoValidation"
                    >
                      <button
                        type="button"
                        class="step-trigger"
                        onClick={() => validateForm() && setActiveTab(2)}
                      >
                        <span class="bs-stepper-circle">
                          <i class="bx bx-user"></i>
                        </span>
                        <span class="bs-stepper-label">
                          <span class="bs-stepper-title">Personne</span>
                          <span class="bs-stepper-subtitle">
                            Information sur le Responsable
                          </span>
                        </span>
                      </button>
                    </div>
                    <div class="line">
                      <i class="bx bx-chevron-right"></i>
                    </div>
                    <div
                      class={activeTab === 3 ? "step active" : "step"}
                      data-target="#billingLinksValidation"
                    >
                      <button
                        type="button"
                        class="step-trigger"
                        onClick={() => validateUserForm() && setActiveTab(3)}
                      >
                        <span class="bs-stepper-circle">
                          <i class="bx bx-detail"></i>
                        </span>
                        <span class="bs-stepper-label">
                          <span class="bs-stepper-title">Agréements</span>
                          <span class="bs-stepper-subtitle">
                            Précisez les agréements
                          </span>
                        </span>
                      </button>
                    </div>
                  </div>
                  <div class="bs-stepper-content px-0">
                    <form>
                      {/* <!-- Account Details --> */}
                      {activeTab === 1 && (
                        <div
                          id="accountDetailsValidation"
                          className={activeTab === 1 ? "content active" : "content"}
                        >
                          <div class="content-header mb-6">
                            <h4 class="mb-0">
                              Informations sur la société de Courtage
                            </h4>
                            <p class="mb-0">
                              Entrez les informations détails de la société de
                              courtage
                            </p>
                          </div>
                          <div class="row g-6">
                            <div class="col-sm-6">
                              <label class="form-label" for="raisonSociale">
                                Dénomination sociale
                              </label>
                              <input
                                type="text"
                                name="raisonSociale"
                                onChange={handleInputChange}
                                id="raisonSociale"
                                value={formData.raisonSociale}
                                class={`form-control ${errors.raisonSociale ? "is-invalid" : ""
                                  }`}
                                placeholder="Nom de la société"
                              />
                              {errors.raisonSociale && (
                                <div className="invalid-feedback">
                                  {errors.raisonSociale}
                                </div>
                              )}
                            </div>
                            <div class="col-sm-6">
                              <label class="form-label" for="siegeSocial">
                                Siège social
                              </label>
                              <input
                                type="text"
                                name="siegeSocial"
                                id="siegeSocial"
                                onChange={handleInputChange}
                                value={formData.siegeSocial}
                                class={`form-control ${errors.siegeSocial ? "is-invalid" : ""
                                  }`}
                                placeholder="Siège social de la société"
                              />
                              {errors.siegeSocial && (
                                <div className="invalid-feedback">
                                  {errors.siegeSocial}
                                </div>
                              )}
                            </div>
                            <div class="col-12 col-md-6">
                              <label class="form-label" for="ville">
                                Ville{" "}
                              </label>
                              <select
                                id="ville"
                                name="ville"
                                class="form-control form-select"
                                value={formData.ville}
                                placeholder="Sélectionnez la ville de la société"
                                onChange={handleInputChange}
                              >
                                {villes &&
                                  villes?.map((vil, id) => (
                                    <option key={id} value={vil.libelleParametre}>
                                      {vil.libelleParametre}
                                    </option>
                                  ))}
                              </select>
                            </div>
                            <div class="col-sm-6">
                              <label class="form-label" for="email">
                                Email de la sociéte de courtage
                              </label>
                              <input
                                type="email"
                                name="email"
                                id="email"
                                onChange={handleInputChange}
                                value={formData.email}
                                class={`form-control ${errors.email ? "is-invalid" : ""
                                  }`}
                                placeholder="Entrez l'adresse mail de la société"
                                aria-label="email"
                              />
                              {errors.email && (
                                <div className="invalid-feedback">
                                  {errors.email}
                                </div>
                              )}
                            </div>

                            <div class="col-12 col-md-6">
                              <label class="form-label" for="telephone1Agence">
                                Numéro de téléphone
                              </label>
                              <div class="input-group">
                                <span class="input-group-text">TG (+228)</span>
                                <input
                                  type="tel"
                                  id="telephone1"
                                  name="telephone1"
                                  inputMode="numeric"
                                  pattern="\\d*"
                                  onKeyDown={digitsOnlyKeyDown}
                                  onChange={handlePhoneChange}
                                  class={`form-control phone-number-mask ${errors.telephone1 ? "is-invalid" : ""
                                    }`}
                                  placeholder="00 00 00 00"
                                  value={formData.telephone1}
                                  maxLength={11} /* 8 chiffres + 3 espaces */
                                />
                                {errors.telephone1 && (
                                  <div className="invalid-feedback">
                                    {errors.telephone1}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-12 col-md-6">
                              <label class="form-label" for="nif">
                                NIF <span class="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                inputMode="numeric"
                                id="nif"
                                name="nif"
                                class={`form-control ${errors.nif ? "is-invalid" : ""
                                  }`}
                                placeholder="Entrez votre NIF"
                                value={formData.nif}
                                onChange={handleInputChange}
                                required
                              />
                              {errors.nif && (
                                <div className="invalid-feedback">{errors.nif}</div>
                              )}
                            </div>

                            <div class="col-12 d-flex justify-content-between">
                              <div></div>
                              <button
                                class="btn btn-primary"
                                type="button"
                                onClick={() => {
                                  validateForm() && setActiveTab(2);
                                }}
                              >
                                {" "}
                                <span class="align-middle d-sm-inline-block d-none me-sm-2 me-0">
                                  Suivant
                                </span>{" "}
                                <i class="bx bx-right-arrow-alt bx-sm me-sm-n2"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                      {/* <!-- Personal Info --> */}
                      {activeTab === 2 && (
                        <div
                          id="personalInfoValidation"
                          className={activeTab === 2 ? "content active" : "content"}
                        >
                          <div class="content-header mb-6">
                            <h4 class="mb-0">Informations Personnelles</h4>
                            <p class="mb-0">Entrez vos informations personnelles</p>
                          </div>
                          <div class="row g-6">
                            <div class="col-sm-6">
                              <label class="form-label" for="nomResponsable">
                                Nom
                              </label>
                              <input
                                type="text"
                                id="nomResponsable"
                                name="nomResponsable"
                                onChange={handleInputChange}
                                class={`form-control ${errors.nomResponsable ? "is-invalid" : ""
                                  }`}
                                placeholder="Entrez votre nom"
                                value={formData.nomResponsable}
                              />
                              {errors.nomResponsable && (
                                <div className="invalid-feedback">
                                  {errors.nomResponsable}
                                </div>
                              )}
                            </div>
                            <div class="col-sm-6">
                              <label class="form-label" for="prenomResponsable">
                                Prénom(s)
                              </label>
                              <input
                                type="text"
                                id="prenomResponsable"
                                name="prenomResponsable"
                                onChange={handleInputChange}
                                class={`form-control ${errors.prenomResponsable ? "is-invalid" : ""
                                  }`}
                                placeholder="Entrez votre prénom"
                                value={formData.prenomResponsable}
                              />
                              {errors.prenomResponsable && (
                                <div className="invalid-feedback">
                                  {errors.prenomResponsable}
                                </div>
                              )}
                            </div>
                            <div class="col-sm-6">
                              <label class="form-label" for="telephoneResponsable">
                                Numéro de téléphone
                              </label>
                              <div class="input-group">
                                <span class="input-group-text">TG (+228)</span>
                                <input
                                  type="tel"
                                  id="telephoneResponsable"
                                  name="telephoneResponsable"
                                  inputMode="numeric"
                                  pattern="\\d*"
                                  onKeyDown={digitsOnlyKeyDown}
                                  onChange={handlePhoneChange}
                                  class={`form-control multi-steps-mobile ${errors.telephoneResponsable ? "is-invalid" : ""
                                    }`}
                                  placeholder="00 00 00 00"
                                  value={formData.telephoneResponsable}
                                  maxLength={11}
                                />
                                {errors.telephoneResponsable && (
                                  <div className="invalid-feedback">
                                    {errors.telephoneResponsable}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <label class="form-label" for="emailResponsable">
                                Adresse mail
                              </label>
                              <input
                                type="email"
                                id="emailResponsable"
                                name="emailResponsable"
                                onChange={handleInputChange}
                                class={`form-control multi-steps-email ${errors.emailResponsable ? "is-invalid" : ""
                                  }`}
                                placeholder="Entrez votre adresse mail"
                                value={formData.emailResponsable}
                              />
                              {errors.emailResponsable && (
                                <div className="invalid-feedback">
                                  {errors.emailResponsable}
                                </div>
                              )}
                            </div>
                            <div class="col-md-12">
                              <label class="form-label" for="adresseResponsable">
                                Adresse de résidence
                              </label>
                              <input
                                type="text"
                                id="adresseResponsable"
                                name="adresseResponsable"
                                onChange={handleInputChange}
                                class="form-control"
                                placeholder="Entrez votre adresse de résidence"
                                value={formData.adresseResponsable}
                              />
                            </div>
                            <div class="col-sm-6">
                              <label class="form-label" for="genreResponsable">
                                Genre
                              </label>
                              <select
                                id="genreResponsable"
                                name="genreResponsable"
                                class="form-control"
                                onChange={handleInputChange}
                                value={formData.genreResponsable}
                              >
                                <option value="MASCULIN">MASCULIN</option>
                                <option value="FEMININ">FEMININ</option>
                              </select>
                            </div>
                            <div class="col-sm-6">
                              <label class="form-label" for="typePieceResponsable">
                                Pièce d'identité
                              </label>
                              <select
                                id="typePieceResponsable"
                                name="typePieceResponsable"
                                class="form-control"
                                onChange={handleInputChange}
                                value={formData.typePieceResponsable}
                              >
                                <option value="CNI">CNI</option>
                                <option value="PASSEPORT">PASSEPORT</option>
                              </select>
                            </div>
                            <div class="col-sm-6">
                              <label class="form-label" for="numIdentiteResponsable">
                                Numéro identité
                              </label>
                              <input
                                type="text"
                                name="numIdentiteResponsable"
                                id="numIdentiteResponsable"
                                inputMode="numeric"
                                onKeyDown={digitsOnlyKeyDown}
                                onChange={handleCNIChange}
                                class={`form-control ${errors.numIdentiteResponsable ? "is-invalid" : ""
                                  }`}
                                placeholder="0000-000-0000"
                                value={formData.numIdentiteResponsable}
                                maxLength={13} /* 4-3-4 avec tirets */
                              />
                              {errors.numIdentiteResponsable && (
                                <div className="invalid-feedback">
                                  {errors.numIdentiteResponsable}
                                </div>
                              )}
                            </div>

                            <div class="col-sm-6">
                              <label class="form-label" for="dateNaissanceResponsable">
                                Date de naissance
                              </label>
                              <input
                                type="date"
                                name="dateNaissanceResponsable"
                                id="dateNaissanceResponsable"
                                onChange={handleDOBChange}
                                class={`form-control ${errors.dateNaissanceResponsable ? "is-invalid" : ""
                                  }`}
                                value={formData.dateNaissanceResponsable}
                                max={TODAY_ISO}
                              />
                              {errors.dateNaissanceResponsable && (
                                <div className="invalid-feedback">
                                  {errors.dateNaissanceResponsable}
                                </div>
                              )}
                            </div>

                            <div class="col-sm-6">
                              <label
                                class="form-label"
                                for="dateDelivranceResponsable"
                              >
                                Date de délivrance{" "}
                              </label>
                              <input
                                type="date"
                                name="dateDelivranceResponsable"
                                id="dateDelivranceResponsable"
                                onChange={handleDateDelivranceChange}
                                class={`form-control ${errors.dateDelivranceResponsable
                                  ? "is-invalid"
                                  : ""
                                  }`}
                                placeholder="Date délivrance de la pièce"
                                value={formData.dateDelivranceResponsable}
                                max={TODAY_ISO}
                                min={formData.dateNaissanceResponsable || undefined}
                              />
                              {errors.dateDelivranceResponsable && (
                                <div className="invalid-feedback">
                                  {errors.dateDelivranceResponsable}
                                </div>
                              )}
                            </div>
                            <div class="col-sm-6">
                              <label
                                class="form-label"
                                for="lieuDelivranceResponsable"
                              >
                                Lieu de délivrance{" "}
                              </label>
                              <select
                                name="lieuDelivranceResponsable"
                                id="lieuDelivranceResponsable"
                                onChange={handleInputChange}
                                class={`form-control form-select ${errors.lieuDelivranceResponsable
                                  ? "is-invalid"
                                  : ""
                                  }`}
                                value={formData.lieuDelivranceResponsable}
                              >
                                <option value="">
                                  Sélectionnez le lieu de délivrance
                                </option>
                                {villes?.map((vil, id) => (
                                  <option key={id} value={vil.libelleParametre}>
                                    {vil.libelleParametre}
                                  </option>
                                ))}
                              </select>
                              {errors.lieuDelivranceResponsable && (
                                <div className="invalid-feedback">
                                  {errors.lieuDelivranceResponsable}
                                </div>
                              )}
                            </div>
                            <div class="col-12 d-flex justify-content-between">
                              <button
                                class="btn btn-primary"
                                onClick={() => {
                                  setActiveTab(1);
                                }}
                              >
                                <i class="bx bx-left-arrow-alt bx-sm ms-sm-n2 me-sm-2"></i>
                                <span class="align-middle d-sm-inline-block d-none">
                                  Précédent
                                </span>
                              </button>
                              <button
                                class="btn btn-primary"
                                type="button"
                                onClick={() => {
                                  validateUserForm() && setActiveTab(3);
                                }}
                              >
                                <span class="align-middle d-sm-inline-block d-none me-sm-2 me-0">
                                  Suivant
                                </span>
                                <i class="bx bx-right-arrow-alt bx-sm me-sm-n2"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                      {/* <!-- Billing Links --> */}
                      {activeTab === 3 && (
                        <div
                          id="billingLinksValidation"
                          className={activeTab === 3 ? "content active" : "content"}
                        >
                          <div class="content-header mb-6">
                            <h4 class="mb-0">Agréements</h4>
                            <p class="mb-0">
                              Pour nous permettre de vous donner les habilitations
                              pour produire pour telle ou telle compagnie, soumettez
                              vos agréemments que vous avez obtenu auprès d'eux
                            </p>
                          </div>
                          {/* <!-- Credit Card Details --> */}
                          <div class="row g-6">
                            <div class="col-md-12">
                              <label class="form-label w-100" for="multiStepsCard">
                                Compagnies
                              </label>
                              <div class="input-group input-group-merge">
                                <Select
                                  mode="multiple"
                                  style={{
                                    width: "100%",
                                  }}
                                  placeholder="Veuillez sélectionner les compagnies avec lesquelles vous avez des agréements"
                                  onChange={handleSelectCompagniesChange}
                                  options={assurances?.map((c, id) => ({
                                    label: c.raisonSociale,
                                    value: JSON.stringify(c),
                                    key: id,
                                  }))}
                                  value={selectedCompagnies}
                                />
                              </div>
                            </div>
                            {selectedCompagnies?.map((sc, id) => (
                              <div class="col-md-12" key={id}>
                                <Upload
                                  name="agreement"
                                  beforeUpload={(file) => {
                                    onChangeBeforeUploadFileSelect(
                                      file,
                                      JSON.parse(sc).code
                                    );
                                    return false; //  Empêche l'upload auto (AntD)
                                  }}
                                  onChange={(e) =>
                                    onChangeFileSelect(e, JSON.parse(sc).code)
                                  }
                                  listType="picture"
                                  maxCount={1}
                                  accept=".pdf,.jpg,.jpeg,.png"
                                >
                                  <Button
                                    style={{ width: "100%" }}
                                    icon={<UploadOutlined />}
                                    block
                                  >
                                    Cliquez pour téléverser l'agréement de{" "}
                                    {JSON.parse(sc).raisonSociale}{" "}
                                  </Button>
                                </Upload>
                              </div>
                            ))}

                            <div class="col-12 d-flex justify-content-between">
                              <button
                                class="btn btn-primary"
                                onClick={() => {
                                  setActiveTab(2);
                                }}
                              >
                                <i class="bx bx-left-arrow-alt bx-sm ms-sm-n2 me-sm-2"></i>
                                <span class="align-middle d-sm-inline-block d-none">
                                  Précédent
                                </span>
                              </button>
                              <button
                                type="submit"
                                class="btn btn-success"
                                onClick={(e) => handleSubmit(e)}
                                disabled={loading}
                              >
                                {loading && (
                                  <span
                                    class="spinner-grow me-1"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                )}
                                {loading ? `Enregistrement...` : `S'enregistrer`}
                              </button>
                            </div>
                          </div>
                          {/* <!--/ Credit Card Details --> */}
                        </div>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </Col>
      </Row>

      <style>{`
        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 991px) {
          .ant-col-lg-12 {
            min-height: 100vh;
          }
        }
      `}</style>
    </div>
  );
};

export default Register;